import React, { Fragment, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { useDispatch, useSelector } from "react-redux";
import PageLayout from "../Layouts/PageLayout";
import { decodeID, encodeID, getLastURL } from "../../utils/Helper";
import { SubscriptionPlanDetailsAction } from "../../Redux/Action/SubscriptionPlanAction";
import { url } from "../../Config/Config";

function SubscriptionPlanView() {
  const dispatch = useDispatch<any>();
  const log_in = useSelector((state: any) => state.AdminLogInState);
  const plan = useSelector((state: any) => state.SubscriptionPlanDetailsState?.data?.data);
  const location = useLocation();
  const editId = getLastURL(location);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(
      SubscriptionPlanDetailsAction({
        detail_id: decodeID(editId),
      }),
    );
    setTimeout(() => setLoading(false), 400);
  }, [dispatch, editId]);

  return (
    <Fragment>
      {loading || log_in?.loading ? <Spinner /> : ""}
      <PageLayout
        title="Subscription plan details"
        breadcrumbs={{
          secLast: { link: "/subscription-plans", name: "Subscription plans" },
        }}
        buttons={[
          {
            url: `${url}/subscription-plan-edit/${encodeID(plan?.id)}`,
            className: "btn btn-primary me-2",
            text: "Edit",
            show: !!plan?.id,
          },
        ]}
      >
        <div className="card">
          <div className="card-body">
            <div className="row gy-4">
              <div className="col-md-6">
                <label className="form-label text-muted">Subscription name</label>
                <p className="mb-0">{plan?.name ?? "—"}</p>
              </div>
              <div className="col-md-6">
                <label className="form-label text-muted">Plan code</label>
                <p className="mb-0">{plan?.plan_code ?? "—"}</p>
              </div>
              <div className="col-12">
                <label className="form-label text-muted">Subscription overview</label>
                <p className="mb-0">{plan?.overview ?? "—"}</p>
              </div>
              <div className="col-md-4">
                <label className="form-label text-muted">Subscription price</label>
                <p className="mb-0">
                  {plan?.price != null ? Number(plan.price).toFixed(2) : "—"}
                </p>
              </div>
              <div className="col-md-4">
                <label className="form-label text-muted">Subscription validity</label>
                <p className="mb-0">
                  {plan?.validity_days != null ? `${plan.validity_days} days` : "—"}
                </p>
              </div>
            </div>

            <hr className="my-4" />
            <h5 className="mb-3">Subscription features</h5>
            <ul className="list-unstyled small text-start">
              <li className="mb-2">
                <strong>Services management:</strong>{" "}
                {plan?.max_services == null
                  ? "Unlimited services."
                  : `Up to ${plan.max_services} services (admin-configurable).`}
              </li>
              <li className="mb-2">
                <strong>Staff management:</strong>{" "}
                {plan?.max_staff == null
                  ? "Unlimited staff members."
                  : `Up to ${plan.max_staff} staff members (admin-configurable).`}
              </li>
              <li className="mb-2">
                <strong>Offline bookings:</strong>{" "}
                {plan?.max_offline_booking_staff == null
                  ? "Add and cancel offline bookings for all staff members."
                  : `Add and cancel offline bookings for up to ${plan.max_offline_booking_staff} staff members (admin-configurable).`}
              </li>
              <li className="mb-2">
                <strong>Growth &amp; statistics:</strong>{" "}
                {plan?.enable_growth_statistics
                  ? "View growth and revenue statistics with filters (month, year, previous year)."
                  : "Disabled for this plan."}
              </li>
              <li className="mb-2">
                <strong>Appointment cancellation:</strong>{" "}
                {plan?.enable_appointment_cancellation
                  ? "Cancel all upcoming appointments."
                  : "Disabled for this plan."}
              </li>
            </ul>

            <Link to={`${url}/subscription-plans`} className="btn btn-light mt-2">
              Back to list
            </Link>
          </div>
        </div>
      </PageLayout>
    </Fragment>
  );
}

export default SubscriptionPlanView;
